module.exports = __webpack_public_path__ + "static/media/390x310-Bogota.e7e06bf7.jpg";